<template>
  <div class="faq-box">
    <button tabindex="0" class="card-header-v2 text-xl flex-align-center pointer" @click="toggleAccordion()" :class="!isOpen ? '' : 'closed-accordion'">
      {{ headline }}
      <img class="accordion-angle-icon" src='/files/lidl/images/new-icons/svg/angle-up-alt.svg' alt="">
    </button>
    <div class="ce_accordion accordion-v2">
      <div class="card-v2">
        <div class="accordion" :class="isOpen ? 'collapse' : ''">
          <div class="card-body-v2 text-base">
            <div v-if="itemisedBillGroup.length > 0" class="full-width overflow-x-auto evn-table">
              <table>
                <tr>
                  <th>Datum</th>
                  <th>Uhrzeit</th>
                  <th v-if="listType === 'simple'">Rufnummer</th>
                  <th v-if="listType === 'simple'">Typ</th>
                  <th v-if="listType === 'data'"></th>
                  <th v-if="listType === 'other'">Bemerkung</th>
                  <th v-if="listType === 'topUpAndVoucher'">Bemerkung</th>
                  <th v-if="listType !== 'topUpAndVoucher'">Dauer</th>
                  <th v-if="listType === 'topUpAndVoucher'">Betrag</th>
                  <th v-if="listType !== 'topUpAndVoucher'">Kosten</th>
                </tr>
                <tr class="row body" v-for="bill in getItemisedBills" :key="bill.id">
                  <td>
                      <div>{{ dateFormatter(bill.actionDate) }}</div>
                  </td>
                  <td>
                      <div>{{ timeFormatter(bill.actionDate) }}</div>
                  </td>
                  <td v-if="listType === 'simple'">
                      <div>{{ bill.destination }}</div>
                  </td>
                  <td v-if="listType === 'simple'">
                      <div>{{ getTyp(bill.typeKey)}}</div>
                  </td>
                  <td v-if="listType === 'data'">
                  </td>
                  <td v-if="listType === 'other'">
                      <div>{{ bill.descriptionServices }}</div>
                  </td>
                  <td v-if="listType === 'topUpAndVoucher'">
                      <div>{{ bill.descriptionTopUps }}</div>
                  </td>
                  <td>
                      <div>{{ durationFormatter(bill.duration) }}</div>
                  </td>
                  <td>
                      <div>{{ currencyFormatter(bill.value / 10000) }}</div>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <p>Für den gewählten Zeitraum liegen keine Einträge in diesem Bereich vor.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EvnAccordion',

  data () {
    return {
      loading: false,
      isOpen: true
    }
  },
  props: {
    listType: {
      type: String,
      default: 'simple'
    },
    headline: {
      type: String,
      default: ''
    },
    itemisedBillGroup: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getTyp (type) {
      switch (type) {
        case 'SMS':
          return 'SMS'
        case 'MMS':
          return 'MMS'
        case 'GPR':
        case 'GPRS':
          return 'Daten'
        default:
          return 'Anruf'
      }
    },
    dateFormatter (date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const century = Math.floor(year / 100)
      const rest = year % 100

      return this.$_makeTwoDigist(d.getDate()) + '.' +
        this.$_makeTwoDigist(d.getMonth() + 1) + '.' +
        this.$_makeTwoDigist(century) + this.$_makeTwoDigist(rest)
    },
    timeFormatter (date) {
      const d = new Date(date)
      const h = d.getHours()
      const m = d.getMinutes()
      const s = d.getSeconds()

      return this.$_makeTwoDigist(h) + ':' +
        this.$_makeTwoDigist(m) + ':' +
        this.$_makeTwoDigist(s)
    },
    dateTimeFormatter (date) {
      return this.$config.calendar.formatter.dateTimeFormatter.format(new Date(date))
    },
    currencyFormatter (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(value)
    },
    durationFormatter (value) {
      if (!value) return ''

      const date = new Date(1900, 1, 1, Math.floor(value / 3600), Math.floor(value / 60) % 60, Math.floor(value % 60))
      return this.$config.calendar.formatter.timeFormatter.format(date)
    },
    $_makeTwoDigist (n) {
      return n > 9 ? '' + n : n < 100 ? '0' + n : '' + n
    },
    toggleAccordion() {
      this.isOpen = !this.isOpen
    }
  },
  computed: {
    getItemisedBills () {
      return this?.itemisedBillGroup
    }
  },
  mixins: [
  ],
  apollo: {
  }
}
</script>
